import React, { useState } from "react";
import { MoveHorizontal } from "lucide-react";

export const BeforeAfterSlider = ({ before, after, title, id }) => {
  const [pos, setPos] = useState(50);
  return (
    <figure className="reveal" data-testid={`before-after-${id}`}>
      <div className="relative aspect-[3/4] w-full overflow-hidden rounded-2xl shadow-card ring-1 ring-brand-mist select-none">
        <img src={after} alt={`After: ${title}`} className="absolute inset-0 h-full w-full object-cover" draggable="false" />
        <img
          src={before}
          alt={`Before: ${title}`}
          className="absolute inset-0 h-full w-full object-cover"
          style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
          draggable="false"
        />
        <span className="absolute top-3 left-3 rounded-full bg-brand-navy/85 px-3 py-1 text-xs font-heading font-bold uppercase tracking-wider text-white">Before</span>
        <span className="absolute top-3 right-3 rounded-full bg-brand-gold px-3 py-1 text-xs font-heading font-bold uppercase tracking-wider text-brand-navy">After</span>
        <div className="pointer-events-none absolute inset-y-0 w-0.5 bg-white shadow" style={{ left: `${pos}%` }}>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-11 w-11 grid place-items-center rounded-full bg-white text-brand-navy shadow-lg">
            <MoveHorizontal className="h-5 w-5" />
          </div>
        </div>
        <input
          type="range"
          min="0"
          max="100"
          value={pos}
          onChange={(e) => setPos(Number(e.target.value))}
          aria-label={`Before and after comparison slider: ${title}`}
          data-testid={`before-after-range-${id}`}
          className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0"
        />
      </div>
      <figcaption className="mt-3 font-heading font-bold text-brand-navy" data-testid={`before-after-title-${id}`}>{title}</figcaption>
    </figure>
  );
};

export const BEFORE_AFTER = [
  { id: "front-entry", title: "Front Entry Screen Door & Rescreen", before: "/photos/ba-front-entry-before.jpg", after: "/photos/ba-front-entry-after.jpg" },
];

export const BeforeAfterSection = ({ className = "pt-16 md:pt-24 bg-white" }) => (
  <section className={className} data-testid="before-after-section">
    <div className="container-x">
      <div className="text-center max-w-2xl mx-auto mb-10">
        <span className="text-brand-ocean text-xs font-heading font-bold uppercase tracking-wider">Rescreen & Repair</span>
        <h2 className="mt-2 text-2xl md:text-4xl font-heading font-extrabold text-brand-navy">Before & After</h2>
        <p className="mt-3 text-slate-600">Drag the slider to see the difference a fresh screen makes.</p>
      </div>
      <div className="flex flex-wrap justify-center gap-8">
        {BEFORE_AFTER.map((p) => (
          <div key={p.id} className="w-full max-w-sm">
            <BeforeAfterSlider {...p} />
          </div>
        ))}
      </div>
    </div>
  </section>
);
